import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';
import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Popover } from 'app/agriculture/components/Popover/Popover';
import { Input, InputAdornment } from '@mui/material';
import { SearchIcon, TargetIcon } from 'app/agriculture/icons';
import { primaryColourMain } from 'app/agriculture/material';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { AddressResults } from 'app/agriculture/routes/BackOffice/FarmCreate/components/AddressResults';

export function FarmLocationSearchInput({
    className,
    onChange = () => {
        /* do nothing */
    },
}: {
    className?: string;
    onChange?: (geometry: PointGeometry) => void;
}) {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebounce(searchTerm, 500);
    const [open, setOpen] = useState(false);

    return (
        <Popover
            open={open && searchTerm === debouncedSearchTerm && searchTerm !== ''}
            triggerInteractions={[]}
        >
            <Popover.Trigger>
                <Input
                    value={searchTerm}
                    onChange={({ currentTarget }) => {
                        setSearchTerm(currentTarget.value);
                        setOpen(true);
                    }}
                    className={className}
                    placeholder="Search by town, postcode or address..."
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon color={primaryColourMain} size={20} />
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="start">
                            <TargetIcon color={primaryColourMain} size={20} />
                        </InputAdornment>
                    }
                />
            </Popover.Trigger>
            <Popover.Content>
                <SuspenseWrapper>
                    <AddressResults
                        searchTerm={debouncedSearchTerm}
                        onSelect={({ properties, geometry }) => {
                            setSearchTerm(properties.displayName);
                            setOpen(false);
                            onChange(geometry);
                        }}
                    />
                </SuspenseWrapper>
            </Popover.Content>
        </Popover>
    );
}
